import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_control_settings",
  "use": "asus_proart_sw_ico_control_settings-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_control_settings\"><g id=\"asus_proart_sw_ico_control_settings_asus_proart_sw_ico_control_settings\"><rect width=\"48\" height=\"48\" style=\"fill:none\" /><path d=\"M12.64,20.89h-2V10h2ZM23,38h2V24H23Zm2-28H23v6.78H19.36v2h9.28v-2H25Zm12.36,0h-2V24h2ZM7,28.11h3.64V38h2V28.11h3.63v-2H7Zm34,1.11H31.73v2h3.63V38h2V31.22H41Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol